import { CURRENT_SERVER } from '@/constants/domains'
import VueCookie from 'vue-cookie'
import axios from 'axios'

export default {
  createTechnicalSupport (body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('support', body)
  },
  editTechnicalSupports (_id, body) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.put(`support/${_id}`, body)
  },
  getSelectFilterTechnicalSupports () {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get('support/selectFilter')
  },
  getTechnicalSupports ({
    page = 1,
    limit = 20,
    status,
    category,
    user
  }) {
    const instCred = axios.create({
      baseURL: CURRENT_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const query = [`page=${page}`, `limit=${limit}`]

    if (status) query.push(`status[]=${status}`)
    if (category) query.push(`category[]=${category}`)
    if (user) query.push(`user[]=${user}`)

    return instCred.get(`support?${query.join('&')}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/TechnicalSupport/api.js